import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import BottomNav from './BottomNav';
import { Phone } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

export default function Layout() {
  const location = useLocation();
  const isCart = location.pathname === '/cart';
  const isSeatAllocation = location.pathname.includes('/seats');
  const hideFooter = isCart || isSeatAllocation;
  const hideBottomNav = isCart || isSeatAllocation;
  const hideNavbar = isSeatAllocation;

  const isShowDetails = location.pathname.startsWith('/shows/') && location.pathname !== '/shows';
  const hideFab = isShowDetails || isSeatAllocation;

  return (
    <div className="flex flex-col min-h-screen relative overflow-x-clip w-full max-w-[100vw]">
      {!hideNavbar && <Navbar />}
      <main className={`flex-grow relative z-0 ${hideBottomNav ? 'pb-0' : 'pb-24 md:pb-0'}`}>
        <AnimatePresence mode="wait">
          <motion.div
            key={location.pathname}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.3, ease: "easeOut" }}
            className="h-full"
          >
            <Outlet />
          </motion.div>
        </AnimatePresence>
      </main>
      {!hideFooter && <Footer />}
      
      {/* Floating Action Button (FAB) */}
      {!hideFab && (
        <a 
          href="tel:+918917493408" 
          title="Call Us: +91 8917493408"
          aria-label="Call Support"
          className="fixed bottom-24 right-4 md:bottom-8 md:right-8 bg-blue-600 hover:bg-blue-700 text-white w-14 h-14 rounded-2xl flex items-center justify-center shadow-[0_8px_16px_rgba(37,99,235,0.4)] z-[40] transition-transform hover:scale-105 active:scale-95"
        >
          <Phone size={24} fill="currentColor" />
        </a>
      )}
      
      {!hideBottomNav && <BottomNav />}
    </div>
  );
}
